export default "__VITE_ASSET__eaa92ea7__"